const text = { type: "string" };
const day = { type: "string", format: "date" };
const object = (properties, required = Object.keys(properties)) => ({
  type: "object",
  properties,
  required,
  additionalProperties: false,
});
export const journalSchema = {
  $schema: "https://json-schema.org/draft/2020-12/schema",
  $id: "https://weekkeep.local/schema/journal-v3",
  ...object({
    version: { const: 3 },
    profile: object({
      name: { ...text, maxLength: 60 },
      birthDate: day,
      horizon: { type: "integer", minimum: 1, maximum: 200 },
    }),
    entries: {
      type: "array",
      items: object(
        {
          id: { ...text, minLength: 1 },
          date: day,
          title: text,
          text,
          memory: text,
          createdAt: { type: "string", format: "date-time" },
          location: {
            anyOf: [
              { type: "null" },
              {
                dependentRequired: {
                  latitude: ["longitude"],
                  longitude: ["latitude"],
                },
                ...object(
                  {
                    label: { ...text, minLength: 1, maxLength: 250 },
                    source: { enum: ["manual", "photon", "browser"] },
                    latitude: { type: "number", minimum: -90, maximum: 90 },
                    longitude: { type: "number", minimum: -180, maximum: 180 },
                    city: { ...text, maxLength: 100 },
                    country: { ...text, maxLength: 100 },
                  },
                  ["label", "source"],
                ),
              },
            ],
          },
        },
        ["id", "date", "title", "text", "memory", "createdAt"],
      ),
    },
    lived: {
      type: "object",
      propertyNames: day,
      additionalProperties: { type: "boolean" },
    },
    closures: {
      type: "object",
      propertyNames: day,
      additionalProperties: object({
        memory: { ...text, minLength: 1 },
        experiment: text,
      }),
    },
    compass: object({
      values: text,
      calls: text,
      chapter: text,
      experiment: text,
    }),
    acknowledged: { type: "array", items: text, uniqueItems: true },
  }),
};
